import React, { FunctionComponent } from 'react';

import { Paper } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import Adherent from '../domain/Adherent';

type Props = {
    adherents: Adherent[] | null,
    loading: boolean,
    submitRequest: boolean
};

const headerCellStyle = {
    backgroundColor: '#1b65ac', 
    color: 'white', 
    paddingTop: 1, 
    paddingBottom: 1, 
    border: '1px solid white'
};

const defaultCellStyle = {
    paddingTop: 1, 
    paddingBottom: 1, 
    border: '1px solid #e0e0e0'
};

const emptyCellStyle = {
    backgroundColor: '#1b65ac', 
    color: 'white', 
    paddingTop: 1, 
    paddingBottom: 1, 
    border: '1px solid white'
}


const AdherentList: FunctionComponent<Props> = ({ adherents, loading, submitRequest }) => {

    //console.log(JSON.stringify(adherents, null, 2));

    return (

        <React.Fragment>

            {/* Résultats de recherche */}
            {adherents && adherents.length > 0 && (
                <TableContainer component={Paper} sx={{ width: '100%'}}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={headerCellStyle}>
                                    N° CSF
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Civilité
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Nom
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Nom de naissance
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Prénom
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Date de naissance
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Adhérent
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Date d'adhésion
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    Date de renouvellement
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {adherents.map((row) => (
                                <TableRow key={row.particulierId}>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.particulierId}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.civilite}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.nom}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.nomNaissance}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.prenom}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.dateNaissance ? row.dateNaissance.toString() : ''}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        {row.indicateurADH}
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        { row.dateAdhesion ? row.dateAdhesion.toString() : '' }
                                    </TableCell>
                                    <TableCell align="center" sx={defaultCellStyle}>
                                        { row.dateRenouvellement ? row.dateRenouvellement.toString() : '' }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            { ( submitRequest === true && loading === false && ((adherents === null || adherents === undefined) || ( adherents && adherents.length === 0 )))  && (
                
                <TableContainer component={Paper} sx={{ marginTop: 4 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    N° CSF
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Civilité
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Nom
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Nom de naissance
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Prénom
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Date de naissance
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Adhérent
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Date d'adhésion
                                </TableCell>
                                <TableCell align="center" sx={emptyCellStyle}>
                                    Date de renouvellement
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align="center" colSpan={11} sx={{ justifyContent: 'center', textAlign: 'center', paddingTop: 1, paddingBottom: 1, border: '1px solid gray'}}>
                                    Aucun résultat
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                        
            )}

        </React.Fragment>
    )

}

export default AdherentList;